export const SET_DARK_MODE = "SET_DARK_MODE";
export const SET_VERSION_MODE = "SET_VERSION_MODE";
export const UPDATE_VERSION_IN_MARKDOWN = "UPDATE_VERSION_IN_MARKDOWN";
